import {useState, useEffect} from "react";
import BookReviewService from "../../services/reviews/BookReviewService";
import IconText from "../IconText";
import {faStar} from "@fortawesome/free-solid-svg-icons/faStar";

export default function BookReviewTable() {
    const [reviews, setReviews] = useState([]);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await BookReviewService.getAllReviews();
                setReviews(data);
            } catch (error) {
                console.error("Failed to fetch reviews:", error);
            }
        };

        fetchReviews();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsNarrowScreen(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const imageStyle = {height: '25px', width: '25px', objectFit: 'cover'};

    const narrowBookNameStyle = {fontWeight: 'bold', textDecoration: 'underline'};

    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th>Book</th>
                    {isNarrowScreen ? (
                        <th>Rating</th>
                    ) : (
                        <>
                            <th>Author</th>
                            <th>Genre</th>
                            <th>Rating</th>
                        </>
                    )
                    }
                </tr>
                </thead>
                <tbody>
                {reviews.map((review) => (
                    <tr key={review.id}
                        style={review.id % 2 === 0 ? {backgroundColor: 'rgba(255, 255, 255, 0.1)'} : {backgroundColor: 'transparent'}}>
                        <td>{isNarrowScreen ? (<><span style={narrowBookNameStyle}>{review.bookName}</span> <br/> <img
                            src={review.imgLink}
                            alt={review.authorName}
                            style={imageStyle}/> {review.authorName}</>) : (review.bookName)}</td>
                        {!isNarrowScreen && <td><img src={review.imgLink} alt={review.authorName}
                                                     style={imageStyle}/> {review.authorName}</td>}
                        {!isNarrowScreen && <td>{review.genre}</td>}
                        <td><IconText icon={faStar} text={review.overallRating} bgColor={true}/></td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}